module.exports = __webpack_public_path__ + "img/bin-c-1-w.e2f8ce35.svg";